<template>
  <router-view v-if="!loading" />
</template>

<script>
  import packageJson from '../package.json';

  export default {
    name: 'App',

    data: () => ({
      loading: true,
      unwatch: null,
    }),

    metaInfo() {
      return {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'MaxDuel',
        // all titles will be injected into this template
        titleTemplate:
          // "%s | Octavia Admin - Vuejs & VuetifyJs Admin Dashboard Template "
          'MaxDuel | The Ultimate Player vs Player Platform',
      };
    },

    created() {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');

      mq.addEventListener('change', (e) => {
        this.$vuetify.theme.dark = e.matches;
      });

      setTimeout(() => (this.loading = false), 1000);
    },

    beforeMount() {
      // eslint-disable-next-line no-console
      console.log(`%c v${packageJson.version}`, 'color: lightseagreen; font-size: 20px;');
      // eslint-disable-next-line no-console
      console.log(
        '%cWarning: Using this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand!',
        'color: red; font-size: 20px;',
      );

      this.$store.dispatch('initializeVisualViewport');
      //Fix documentElement scrolling
      //TODO: figure out why scrollTop jumps back to 0 if only ~20px have been scrolled
      // this.unwatch = this.$store.watch(
      //   (state, getters) => getters.getVisualViewportScroll,
      //   () => {
      //     window.scrollTo(0, 0);
      //   },
      // );
    },
    beforeDestroy() {
      // this.unwatch();
      this.$store.dispatch('destroyVisualViewportListener');
    },
  };
</script>

<style lang="scss">
  @import '@/scss/inputStyling.scss';

  .v-main[app] {
    transition: 0.35s ease;
    will-change: contents;
    transform-style: preserve-3d;

    &.v-main--logged-in:not(.v-main--no-offset) {
      @media screen and (min-width: 960px) and (max-width: 1440px) {
        transform: none;
      }

      @media screen and (min-width: 1601px) {
        transform: translateX(-160px);
      }

      @media screen and (min-width: 1792px) {
        transform: translateX(-188px);
      }
    }
  }

  .not-found-page .v-main[app] {
    transform: none;
  }

  .nav-drawer.v-navigation-drawer {
    transition: 0.35s ease;
    will-change: transform, visibility, width;
    transform-style: preserve-3d;

    @media screen and (max-width: 600px) {
      transition: 0.2s ease;
    }
  }
</style>
